import { useQuery } from "@rocicorp/zero/react";
import type { ReactNode } from "react";
import { queries } from "../../../shared/queries";
import type { ChatReference } from "../../hooks/useChatReference";
import { ConnectorLogo } from "../ConnectorLogo";
import { Icon, type IconName } from "../Icon";
import { Link } from "../Link";
import {
  ChatPillLabel,
  chatPillClassName,
  inlineChatPillClassName,
} from "./chatPill";

const iconStyle = { flexShrink: 0 };

const REFERENCE_ICONS: Partial<Record<ChatReference["type"], IconName>> = {
  space: "hash",
  group: "users-round",
  member: "id-card",
  role: "id-card-lanyard",
  serviceAccount: "bot",
  network: "runs",
  aiProvider: "brain",
  skill: "skills",
  admins: "building-2",
  connector: "plug",
};

function ConnectorReferenceLogo({ id }: { id: string }) {
  const [connectors] = useQuery(queries.connectedAppsLite());
  const connector = connectors.find((candidate) => candidate.id === id);
  if (!connector) return <Icon name="plug" size={10} style={iconStyle} />;
  return (
    <span aria-hidden="true" style={{ display: "inline-flex", flexShrink: 0 }}>
      <ConnectorLogo app={connector} size={10} faded={false} />
    </span>
  );
}

export function ChatReferencePill({
  reference,
  children,
}: {
  reference: ChatReference;
  children: ReactNode;
}) {
  return (
    <Link
      to={reference.href}
      className={`${chatPillClassName} ${inlineChatPillClassName}`}
    >
      {reference.type === "connector" && reference.id ? (
        <ConnectorReferenceLogo id={reference.id} />
      ) : (
        <Icon
          name={REFERENCE_ICONS[reference.type] ?? "link-2"}
          size={10}
          style={iconStyle}
        />
      )}
      <ChatPillLabel>{children}</ChatPillLabel>
    </Link>
  );
}
